<template>
  <div class="form-row">
    <div class="form-group col-md-6">
      <label for="input_start_date_time">{{startLabel}}</label>
      <flat-pickr class="form-control"
        v-model="start"
        :config="config.start"></flat-pickr>
      <b-form-feedback>Please input a valid date time</b-form-feedback>
    </div>
    <div class="form-group col-md-6">
      <label for="input_end_date_time">{{endLabel}}</label>
      <flat-pickr class="form-control"
        v-model="end"
        :config="config.end"></flat-pickr>
      <b-form-feedback>Please input a valid date time</b-form-feedback>
    </div>
  </div>
</template>
<script>
import flatPickr from 'vue-flatpickr-component';
// import { Indonesian } from 'flatpickr/dist/l10n/id.js';

import 'flatpickr/dist/flatpickr.css';
import { parse } from 'date-fns';

export default {
  components: {
    flatPickr,
  },
  props: {
    name: String,
    startLabel: {
      type: String,
      default: 'Start Date Time',
    },
    endLabel: {
      type: String,
      default: 'End Date Time',
    },
  },
  data() {
    return {
      start: null,
      end: null,
      config: {
        start: {
          // locale: Indonesian, TODO: Create config for locale
          enableTime: true,
          enableSeconds: true,
          time_24hr: true,
          allowInput: true,
          defaultHour: 0,
          defaultMinute: 0,
        },
        end: {
          // locale: Indonesian,
          enableTime: true,
          enableSeconds: true,
          time_24hr: true,
          allowInput: true,
          defaultHour: 23,
          defaultMinute: 59,
          defaultSecond: 59, // FIXME: Set default second not working
        },
      },
    };
  },
  watch: {
    start(val) {
      if (val) {
        const date = parse(val);
        this.$set(this.config.end, 'minDate', date);
        this.updateChanges();
      }
    },
    end(val) {
      if (val) {
        const date = parse(val);
        this.$set(this.config.start, 'maxDate', date);
        this.updateChanges();
      }
    },
  },
  methods: {
    updateChanges() {
      this.$emit('change', this.name, {
        start: this.start,
        end: this.end,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/report_options/DateTimeRange.vue